// Firestore service for consolidated portfolio snapshots (multi-provider)
import {
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  limit,
  query,
  documentId,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

function getConsolidatedCollectionRef(userId, entityId) {
  if (!userId || !entityId) throw new Error("userId and entityId are required");
  return collection(
    db,
    `users/${userId}/entities/${entityId}/investments/consolidated/portfolio`
  );
}

export async function getConsolidatedLatest(userId, entityId) {
  const col = getConsolidatedCollectionRef(userId, entityId);
  const q = query(col, orderBy(documentId(), "desc"), limit(1));
  const snap = await getDocs(q);
  if (snap.empty) return null;
  const d = snap.docs[0];
  return { id: d.id, ...d.data() };
}

export async function getConsolidatedByDate(userId, entityId, dateId) {
  const ref = doc(
    db,
    `users/${userId}/entities/${entityId}/investments/consolidated/portfolio/${dateId}`
  );
  const snap = await getDoc(ref);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function getConsolidatedHistory(userId, entityId, max = 90) {
  const col = getConsolidatedCollectionRef(userId, entityId);
  const q = query(col, orderBy(documentId(), "desc"), limit(max));
  const snap = await getDocs(q);
  const results = [];
  snap.forEach((d) => results.push({ id: d.id, ...d.data() }));
  return results.reverse();
}
